import React from 'react';
import {Anchor, Card, Divider, List, Typography} from 'antd';

const { Title, Paragraph, Text } = Typography;

function HelpPage() {
  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', width: '100%' }}>
      <Card style={{ marginBottom: 16 }}>
        <Title level={2} style={{ marginTop: 0 }}>메타데이터 관리 시스템 사용자 도움말</Title>
        <Paragraph>
          이 시스템은 용어/단어/도메인/프로젝트와 시스템 설정(메뉴/그룹/사용자/권한/API/이벤트)을 통합 관리합니다.
          우측 상단 사용자 메뉴에서 로그인/프로필/도움말을 이용할 수 있습니다. 일부 기능은 권한이 있어야 사용 가능합니다.
        </Paragraph>
        <Anchor
          affix={false}
          items={[
            { key: 'toc-start', href: '#시작하기', title: '시작하기' },
            { key: 'toc-home', href: '#홈-대시보드', title: '홈 대시보드' },
            { key: 'toc-nav-auth', href: '#메뉴-내비게이션과-권한', title: '메뉴 내비게이션과 권한' },
            { key: 'toc-terms', href: '#용어-관리', title: '용어 관리' },
            { key: 'toc-words', href: '#단어-관리', title: '단어 관리' },
            { key: 'toc-domains', href: '#도메인-관리', title: '도메인 관리' },
            { key: 'toc-projects', href: '#프로젝트-관리', title: '프로젝트 관리' },
            { key: 'toc-system', href: '#시스템-설정', title: '시스템 설정(관리자)' },
            { key: 'toc-excel', href: '#엑셀-업로드-다운로드', title: '엑셀 업로드/다운로드' },
            { key: 'toc-profile', href: '#사용자-프로필', title: '사용자 프로필' },
            { key: 'toc-trouble', href: '#자주-묻는-질문과-문제-해결', title: '자주 묻는 질문과 문제 해결' },
          ]}
        />
      </Card>

      <Card id="시작하기" style={{ marginBottom: 16 }}>
        <Title level={3} style={{ marginTop: 0 }}>시작하기</Title>
        <List
          size="small"
          dataSource={[
            '게스트: 최초 접속 시 게스트로 자동 로그인될 수 있습니다(읽기 위주, 일부 제한).',
            '로그인: 우측 상단 [로그인] 버튼 또는 사용자 메뉴에서 로그인합니다.',
            '회원가입: 로그인 모달의 [회원가입] 링크 또는 /signup 화면에서 계정을 생성합니다.',
            '권한: 계정에 부여된 권한/그룹에 따라 메뉴/버튼이 비활성화되거나 숨겨질 수 있습니다.',
          ]}
          renderItem={(item) => <List.Item><Text>{item}</Text></List.Item>}
        />
      </Card>

      <Card id="홈-대시보드" style={{ marginBottom: 16 }}>
        <Title level={3} style={{ marginTop: 0 }}>홈 대시보드</Title>
        <Paragraph>
          홈에서는 용어/단어/도메인/프로젝트의 개요 수치와 간단한 분포, 최근 7일 추이를 확인하고 해당 목록으로 이동할 수 있습니다.
          권한이 없는 항목은 접근 불가로 표시되거나 숫자가 대시(-)로 표시됩니다.
        </Paragraph>
      </Card>

      <Card id="메뉴-내비게이션과-권한" style={{ marginBottom: 16 }}>
        <Title level={3} style={{ marginTop: 0 }}>메뉴 내비게이션과 권한</Title>
        <Paragraph>
          상단 메뉴는 시스템의 메뉴 설정에 따라 동적으로 표시됩니다. 비활성화된 항목은 흐리게 보이며 클릭할 수 없습니다.
          각 화면의 주요 버튼은 API 권한에 따라 자동으로 활성/비활성 처리됩니다.
        </Paragraph>
      </Card>

      <Card id="용어-관리" style={{ marginBottom: 16 }}>
        <Title level={3} style={{ marginTop: 0 }}>용어 관리</Title>
        <Paragraph>
          메뉴: [용어] (/terms)
        </Paragraph>
        <List
          size="small"
          header={<b>기능</b>}
          dataSource={[
            '검색: 용어명/설명/영문약어/도메인명/동의어 등 열 기준으로 필터링',
            '선택 삭제: 체크박스로 선택 후 일괄 삭제',
            '엑셀 업로드: A: 용어명*, B: 설명*, C: 영문약어, D: 도메인명, E: 동의어',
            '엑셀 다운로드: 현재 그리드 표시 순서/필터를 반영해 다운로드 (첫 열: UUID 포함)',
            '단건 생성: 모달에서 용어 데이터 추가',
          ]}
          renderItem={(item) => <List.Item><Text>{item}</Text></List.Item>}
        />
      </Card>

      <Card id="단어-관리" style={{ marginBottom: 16 }}>
        <Title level={3} style={{ marginTop: 0 }}>단어 관리</Title>
        <Paragraph>
          메뉴: [단어] (/words)
        </Paragraph>
        <List
          size="small"
          header={<b>기능</b>}
          dataSource={[
            '검색: 단어명/영문약어/영문명/설명/도메인/동의어/금칙어 등으로 필터링',
            '선택 삭제: 체크박스로 선택 후 일괄 삭제',
            '엑셀 업로드: 열 순서 = UUID | 단어명* | 영문약어* | 영문명* | 설명* | 도메인 | 동의어 | 금칙어 (업서트 권한 없는 경우 UUID는 무시되어 신규 생성)',
            '엑셀 다운로드: 현재 그리드 표시 순서/필터를 반영해 다운로드 (첫 열: UUID 포함)',
            '단건 생성: 모달에서 단어 데이터 추가',
          ]}
          renderItem={(item) => <List.Item><Text>{item}</Text></List.Item>}
        />
      </Card>

      <Card id="도메인-관리" style={{ marginBottom: 16 }}>
        <Title level={3} style={{ marginTop: 0 }}>도메인 관리</Title>
        <Paragraph>
          메뉴: [도메인] (/domains)
        </Paragraph>
        <List
          size="small"
          header={<b>기능</b>}
          dataSource={[
            '검색: 그룹/분류/도메인명/설명/데이터유형 등으로 필터링',
            '선택 삭제: 체크박스로 선택 후 일괄 삭제',
            '엑셀 업로드: A: 도메인그룹명* | B: 도메인분류명* | C: 도메인명* | D: 도메인설명 | E: 데이터유형* | F: 데이터길이 | G: 소수점길이 | H: 저장형식 | I: 표시형식 | J: 단위 | K: 허용값',
            '엑셀 다운로드/새로고침 지원',
            '단건 생성: 모달에서 도메인 데이터 추가',
          ]}
          renderItem={(item) => <List.Item><Text>{item}</Text></List.Item>}
        />
      </Card>

      <Card id="프로젝트-관리" style={{ marginBottom: 16 }}>
        <Title level={3} style={{ marginTop: 0 }}>프로젝트 관리</Title>
        <Paragraph>
          메뉴: [프로젝트] (/projects)
        </Paragraph>
        <List
          size="small"
          header={<b>목록/카드</b>}
          dataSource={[
            '프로젝트 생성/수정/삭제(권한 필요), 카드 클릭 시 상세 탭으로 이동',
          ]}
          renderItem={(item) => <List.Item><Text>{item}</Text></List.Item>}
        />
        <Divider />
        <List
          size="small"
          header={<b>상세 탭</b>}
          dataSource={[
            '프로젝트 정보: 기본 정보 확인 및 멤버 추가/삭제',
            '프로젝트 메뉴: 트리 형태로 메뉴 구성 관리, 드래그앤드롭으로 순서/계층 변경, 엑셀 업/다운로드',
            '프로젝트 용어: 그리드 검색/선택 삭제, 엑셀 업로드(업서트 권한 시 UUID로 업데이트)',
            '프로젝트 단어: 그리드 검색/선택 삭제, 엑셀 업로드(업서트 권한 시 UUID로 업데이트)',
            '프로젝트 도메인: 도메인 탭(구성에 따라 제공)에서 관리',
          ]}
          renderItem={(item) => <List.Item><Text>{item}</Text></List.Item>}
        />
      </Card>

      <Card id="시스템-설정" style={{ marginBottom: 16 }}>
        <Title level={3} style={{ marginTop: 0 }}>시스템 설정(관리자)</Title>
        <Paragraph>
          메뉴: [시스템 설정] (/system/menus)
        </Paragraph>
        <List
          size="small"
          header={<b>탭 구성</b>}
          dataSource={[
            '메뉴 관리: 시스템 상단/좌측 메뉴 구조와 사용여부/정렬 관리',
            '그룹 관리: 사용자/메뉴/API 그룹 생성 및 멤버 구성',
            '사용자 관리: 사용자 생성/수정/삭제, 필터/일괄삭제 제공',
            '권한 관리: 사용자그룹 → (메뉴/오 API)그룹 권한 매핑',
            'API 관리: API 리소스 등록/수정/삭제, 미등록 항목 일괄 등록',
            '이벤트 관리: 시스템 이벤트 로그/현황(구성에 따라)',
          ]}
          renderItem={(item) => <List.Item><Text>{item}</Text></List.Item>}
        />
      </Card>

      <Card id="엑셀-업로드-다운로드" style={{ marginBottom: 16 }}>
        <Title level={3} style={{ marginTop: 0 }}>엑셀 업로드/다운로드</Title>
        <List
          size="small"
          header={<b>공통 안내</b>}
          dataSource={[
            '다운로드: 현재 그리드의 표시 열/순서/필터 상태를 반영해 작성됩니다. 첫 열에는 UUID가 포함될 수 있습니다.',
            '업로드: 업로드 모달에 열 순서 가이드가 제공됩니다. * 표시는 필수 항목입니다.',
            '업서트 권한: 프로젝트 용어/단어 등은 업서트 권한이 있을 때 UUID 기준 업데이트가 가능합니다. 권한이 없으면 모두 신규 생성으로 처리됩니다.',
          ]}
          renderItem={(item) => <List.Item><Text>{item}</Text></List.Item>}
        />
      </Card>

      <Card id="사용자-프로필" style={{ marginBottom: 16 }}>
        <Title level={3} style={{ marginTop: 0 }}>사용자 프로필</Title>
        <Paragraph>
          우측 상단 사용자 메뉴의 [프로필]에서 정보 확인, [프로필 수정]에서 이름/프로필URL/이메일/비밀번호 변경이 가능합니다(프로필 URL은 http(s)만 허용).
        </Paragraph>
      </Card>
    </div>
  );
}

export default HelpPage;

